// 系统管理员的菜单通配权限不能代替全员聊天管理的专门授权。
export function chatManagementMenus(menus, allowed = false, driveAllowed = false) {
  return (Array.isArray(menus) ? menus : []).filter(item => {
    if (!item) return false
    const protectedChatMenu = ['oa_file_center', 'oa_chat_audit'].includes(item.code) ||
      /^#?\/(fileCenter|chatAudit)(?:[/?#]|$)/.test(item.jumpUrl || '') ||
      /^oa:(file-center:|chat-audit:)/.test(item.perms || '')
    const protectedDriveMenu = item.code === 'oa_personal_drive' ||
      /^#?\/personalDrive(?:[/?#]|$)/.test(item.jumpUrl || '') ||
      item.perms === 'oa:drive:manage'
    return (allowed === true || !protectedChatMenu) &&
      (driveAllowed === true || !protectedDriveMenu)
  }).map(item => Array.isArray(item.children)
    ? {...item, children: chatManagementMenus(item.children, allowed, driveAllowed)} : item)
}
